/* N1 · Comparador en popup del catálogo: chips, filtro por talla, resumen y vuelta al catálogo.
   07/10/2026 (multidioma fase 2, lote 3b): textos desde window.N1T (n1.cmp.*); el guante se identifica por ID (h) y su tarjeta
   del catálogo se busca por el handle del idioma (hd).
   11/10/2026 (paquete H2, AY-13): precio rebajado con el PVP tachado (cap/pcap de snippets/n1-compare-items). */
(function(){
if(window.N1CatCmp)return;window.N1CatCmp=1;
var D=null,sel=[],MAX=3;
var T=function(k,d){var v=window.N1T&&window.N1T[k];return (typeof v==='string'&&v&&!/translation missing/i.test(v))?v:d},F=function(s,o){return String(s).replace(/\{(\w+)\}/g,function(m,k){return o&&o[k]!=null?o[k]:m})};
function nums(t){return (t||'').split(/[^0-9]+/).filter(Boolean).map(Number)}
function data(){
  if(D)return D;
  var s=document.getElementById('cmpdpop');
  if(!s)return null;
  try{D=JSON.parse(s.textContent)}catch(e){D=null}
  return D;
}
function pop(){return document.getElementById('n1k-cpop')}
function open(){var p=pop();if(!p)return;build();p.classList.add('on');document.documentElement.classList.add('n1k-lock')}
function close(){var p=pop();if(!p)return;p.classList.remove('on');document.documentElement.classList.remove('n1k-lock')}
function it(h){var d=data();if(!d)return null;for(var i=0;i<d.items.length;i++)if(d.items[i].h===h)return d.items[i];return null}
var ORDER=[/hera/i,/zeus(?!.*kids)/i,/sirius.*ugt/i,/scorpius.*ugt/i,/horus(?!.*kids)/i,/ares.*ugt/i,/gea/i,/cronos.*duo/i,/cronos.*ugt/i,/beta(?!.*kids)/i,/scorpius.*ssg/i,/sirius.*ssg/i,/cronos.*ssg/i,/kids|niñ|fluor|purple/i,/starter/i];
function rank(t){for(var i=0;i<ORDER.length;i++)if(ORDER[i].test(t))return i;return 98}
function build(){
  var p=pop(),d=data();if(!p||!d||p.dataset.built)return;
  p.dataset.built=1;
  var bar=p.querySelector('[data-cbar]');
  var list=d.items.slice().sort(function(a,b){return rank(a.t)-rank(b.t)});
  var all={};
  list.forEach(function(x){
    var tl=nums(x.specs.tallas);
    tl.forEach(function(n){all[n]=1});
    var c=document.createElement('button');
    c.type='button';c.className='chip';c.setAttribute('data-h',x.h);
    c.dataset.tallas=tl.join(',');
    c.innerHTML='<img src="'+x.img+'" alt="" loading="lazy"><span>'+x.t+'</span>';
    bar.appendChild(c);
  });
  var sizes=Object.keys(all).map(Number).sort(function(a,b){return a-b});
  if(sizes.length){
    var f=document.createElement('div');
    f.className='n1cf';
    f.innerHTML='<span class="n1cf__l">'+T('n1.cmp.your_size','Tu talla')+'</span><div class="n1cf__g"><button type="button" class="n1cf__b on" data-t="">'+T('n1.cmp.all_sizes','Todas')+'</button>'+
      sizes.map(function(n){return '<button type="button" class="n1cf__b" data-t="'+n+'">'+n+'</button>'}).join('')+'</div>';
    bar.parentNode.insertBefore(f,bar);
    f.addEventListener('click',function(e){
      var b=e.target.closest('.n1cf__b');if(!b)return;
      f.querySelectorAll('.n1cf__b').forEach(function(x){x.classList.remove('on')});
      b.classList.add('on');
      var t=b.getAttribute('data-t');
      bar.querySelectorAll('.chip').forEach(function(c){
        var l=(c.dataset.tallas||'').split(',');
        c.style.display=(!t||l.indexOf(t)>-1)?'':'none';
      });
    });
  }
  list.slice(0,2).forEach(function(x){sel.push(x.h);var c=bar.querySelector('.chip[data-h="'+x.h+'"]');if(c)c.classList.add('on')});
  render();
}
function cell(v){if(!v)return '<span class="no">—</span>';var t=v.trim().toLowerCase();
 if(t==='sí'||t==='si'||t==='yes'||t==='sim')return '<span class="yes">'+T('n1.cmp.yes','Sí')+'</span>';if(t==='no'||t==='não'||t==='nao')return '<span class="no">'+T('n1.cmp.no','No')+'</span>';return v}
function render(){
  var p=pop(),d=data();if(!p||!d)return;
  var heads=p.querySelector('[data-heads]'),rows=p.querySelector('[data-rows]');
  heads.innerHTML=sel.map(function(h){var x=it(h);if(!x)return '';
    return '<div class="hd"><img src="'+x.img+'" alt="'+x.t+'" loading="lazy"><div class="b"><b>'+x.t+'</b><span>'+x.price+(x.cap?'<s>'+x.pcap+'</s>':'')+'</span>'+
      '<button type="button" class="n1cpop__go" data-go="'+x.h+'">'+T('n1.cmp.see_cat','Ver en el catálogo')+'</button>'+
      '<a class="n1cpop__fi" href="'+x.u+'">'+T('n1.cmp.see_page','Ver ficha')+' ›</a></div></div>'}).join('');
  var html='';
  d.rows.forEach(function(row){
    var vals=sel.map(function(h){var x=it(h);return x?(x.specs[row.k]||''):''});
    if(vals.every(function(v){return !v}))return;
    var same=vals.every(function(v){return v===vals[0]});
    html+='<div class="row '+((!same&&sel.length>1)?'diff':'')+'"><div class="lb">'+row.l+'</div><div class="vals" style="--n:'+sel.length+'">'+
      vals.map(function(v,j){return '<div><em>'+it(sel[j]).t+'</em>'+cell(v)+'</div>'}).join('')+'</div></div>';
  });
  rows.innerHTML=html;
  var root=p.querySelector('.n1-compare');if(root)root.style.setProperty('--nsel',sel.length);
  document.dispatchEvent(new CustomEvent('n1cmp:render'));
}
function goCatalog(h){
  var x=it(h);if(!x)return;
  close();
  setTimeout(function(){
    var card=document.querySelector('#n1k-grid a[href*="/products/'+(x.hd||h)+'"]');
    if(card){
      var box=card.closest('article,.n1k-card,li,div')||card;
      box.scrollIntoView({behavior:'smooth',block:'center'});
      box.classList.add('n1cpop-hit');
      setTimeout(function(){box.classList.remove('n1cpop-hit')},2600);
    }else{location.href=x.u}
  },180);
}
function addBtn(){
  var sec=document.querySelector('.n1k[data-mode="guantes"]');if(!sec)return;
  var bar=sec.querySelector('.n1k-ksz');if(!bar||bar.dataset.cmp)return;
  var ref=bar.querySelector('.n1k-kasis')||bar.querySelector('.n1k-kfind');if(!ref)return;
  bar.dataset.cmp=1;
  var b=document.createElement('button');
  b.type='button';b.className='n1k-kfind n1k-kcmp';b.setAttribute('data-cmp-open','');
  b.innerHTML='<svg viewBox="0 0 24 24"><path d="M4 5h6v14H4zM14 5h6v14h-6z"/><path d="M10 12h4"/></svg>'+T('n1.cmp.open','Comparar guantes');
  ref.parentNode.insertBefore(b,ref.nextSibling);
}
document.addEventListener('click',function(e){
  if(e.target.closest('[data-cmp-open]')){e.preventDefault();open();return}
  var p=pop();if(!p)return;
  if(e.target.closest('[data-cclose]')||e.target===p){close();return}
  var go=e.target.closest('[data-go]');
  if(go){goCatalog(go.getAttribute('data-go'));return}
  var c=e.target.closest('#n1k-cpop .chip');
  if(c){
    var h=c.getAttribute('data-h'),i=sel.indexOf(h);
    if(i>-1){if(sel.length<3)return;sel.splice(i,1);c.classList.remove('on')}
    else{if(sel.length>=MAX){var o=sel.shift();var old=p.querySelector('.chip[data-h="'+o+'"]');if(old)old.classList.remove('on')}sel.push(h);c.classList.add('on')}
    render();
  }
});
document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
function run(){addBtn()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
addEventListener('load',run);setTimeout(run,700);setTimeout(run,1600);
})();
